var $ea0401974d81b469$exports = {};
$ea0401974d81b469$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};


export {$ea0401974d81b469$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
